// Ported from qr-phone-frontend src/app/services/logger.service.tsx (v3.2.0.0).
import { globals } from './globals'

// PRINT THE MESSAGE ON CONSOLE AND KEEP A BOUNDED IN-MEMORY TRAIL.
export const createLog = (...args: any[]) => {
  const maxLogRows = 30

  if (globals.logList.length > maxLogRows) {
    globals.logList.shift()
  }

  args = args.map((arg) => {
    if (typeof arg === 'object') {
      return JSON.stringify(arg)
    }
    return arg + ''
  })
  const logString = args.join(', ')
  let type = 'log'

  if (args.includes('error')) {
    console.error(logString)
    type = 'e'
  } else if (args.includes('warn')) {
    console.warn(logString)
    type = 'w'
  } else {
    console.log(logString)
  }
  globals.logList.push({ l: logString, t: type })
}
